import { store } from "WithProviders";
import moment from "moment/moment";
import { AnyAction } from "redux";
import { getFromHub } from "./networkActions";
import { getExcursionImages } from "modules/excursions/hooks/useGetExcursionImages";
import { IItinerary } from "interfaces/ReduxState/IItinerary";
import { getRandomImage } from "utils/imageUtils";

const randomCoverPlaceholderImage = getRandomImage();

export interface CruisesActions extends AnyAction {
  cruises?: any;
  cruiseStartDate?: any;
  cruiseHeaderImage?: any;
}

export const clearCruises = () => {
  store.dispatch({ type: "CLEAR_CRUISES" });
};

export const setCruises = (cruises: any) => {
  const cruiseDates = cruises.length
    ? cruises.map((cruise: any) => moment(cruise.fromDate, "DD/MM/YYYY"))
    : null;
  const cruiseStartDate = cruiseDates
    ? moment.min(cruiseDates).format("DD/MM/YYYY")
    : null;

  const cruiseToDates = cruises.length
    ? cruises.map((cruise: any) => moment(cruise.toDate, "DD/MM/YYYY"))
    : null;

  const cruiseEndDate = cruiseToDates
    ? moment.max(cruiseToDates).format("DD/MM/YYYY")
    : null;

  store.dispatch({
    type: "SET_CRUISES",
    cruises,
    cruiseStartDate,
    cruiseEndDate,
  });
};

export const preloadCruiseHeaderImage = async (imageUrl: string) => {
  return new Promise<string>((resolve) => {
    const img = new Image();
    img.onload = () => resolve(imageUrl);
    img.onerror = () => resolve(randomCoverPlaceholderImage);
    img.src = imageUrl;
  });
};

export const getExcursionImageFromFirstItinerary = async (
  itineraries: IItinerary[]
) => {
  const firstItineraryWithBookableExcursions = itineraries
    // Skip first itinerary as it is not bookable for excursions
    ?.slice(1)
    .find(
      (currentItinerary) => currentItinerary?.numberOfBookableExcursions > 0
    );
  const firstBookableExcursions = await getFromHub(
    `prebooking/cruises/itinerary/${firstItineraryWithBookableExcursions?.id}/excursions`
  );
  // excursion images data from first bookable excursions
  const excursionImagesData = await getExcursionImages(
    firstBookableExcursions?.[0]?.excursion?.id
  );
  // first image url
  const cruiseHeaderImageUrl = excursionImagesData?.[0]?.itemPublicUrl;

  return await preloadCruiseHeaderImage(cruiseHeaderImageUrl);
};

export const setCruiseHeaderImage = async (itinerary: IItinerary[]) => {
  const cruiseHeaderImage = await getExcursionImageFromFirstItinerary(
    itinerary
  );

  if (cruiseHeaderImage) {
    store.dispatch({
      type: "SET_CRUISE_HEADER_IMAGE",
      image: cruiseHeaderImage,
    });
  }
};

export const getCurrentCruisesFromStore = () => {
  return store.getState().cruises;
};
